import { chunk as arrayChunk } from 'lodash-es';
import { report, reportSendBeacon } from '../../api';
import { ReportAction } from '../../api/operations';
import store from '../../store';

// 上报缓存队列
let actionBuffer: Array<ReportAction> = [];
// 上报interval
let uploadInterval: number;

// 批量上报时间间隔
const UPLOAD_INTERVAL = 10000;
// 上报数量限制
const UPLOAD_LIMIT = 10;
// 重新上传次数
let retryCount = 0;


/**
 * 添加上报行为
 * @param action 上报行为
 */
export const addAction = (action: ReportAction) => {
  actionBuffer.push(action);
};

/**
 * 清空上报缓存
 */
export const clearActions = () => {
  actionBuffer = [];
};

/**
 * 上报到后端
 * @returns
 */
const uploadActions = () => {
  if (!actionBuffer.length) return;
  const chunks = arrayChunk(actionBuffer, UPLOAD_LIMIT);
  clearActions();
  chunks.forEach((chunk) => {
    uploadActionsChunk(chunk);
  });
};

/**
 * 上报事件分片
 * @param chunk 事件分片
 */
const uploadActionsChunk = async (chunk: Array<ReportAction>) => {
  try {
    const res: any = await report({ action_list: chunk });
    uploadComplete(!!res.report, chunk);
  } catch (error) {
    uploadComplete(false, chunk);
  }
};

/**
 * 上报完成处理
 * @param isSuccess 是否成功
 */
const uploadComplete = (isSuccess: boolean, chunk: Array<ReportAction>) => {
  // 上报成功：重试次数置0
  if (isSuccess) {
    retryCount = 0;
    return;
  }
  // 上报不成功：RETRY_TIMES次以内重新上传
  retryCount += 1;
  if (retryCount <= (store.config.retryTimes || 0)) {
    actionBuffer.push(...chunk);
  }
};

/**
 * 上报所有事件，用于页面离开时上报
 */
const browserSupportsKeepalive = 'keepalive' in new Request('');
export const uploadAll = async () => {
  // 上报存量缓存
  if (actionBuffer.length) {
    const actions = [...actionBuffer];
    clearActions();
    if (browserSupportsKeepalive) {
      try {
        const res = await report({ action_list: actions });
        uploadComplete(!!res.report, actions);
      } catch (error) {
        uploadComplete(false, actions);
      }
    } else { // firefox暂不支持keepalive，采用sendBeacon兼容
      const isSended = reportSendBeacon({ action_list: actions });
      uploadComplete(isSended, actions);
    }
  }
};

/**
 * 开启间隔上报
 * @param interval 间隔时间，默认5s
 */
export const startUploadInterval = (interval = UPLOAD_INTERVAL) => {
  uploadInterval = window.setInterval(() => {
    uploadActions();
  }, interval);
};

/**
 * 清除上报间隔
 */
export const clearUploadInterval = () => {
  uploadAll();
  window.clearInterval(uploadInterval);
};
